import { render, staticRenderFns } from "./NetflixCopyright.vue?vue&type=template&id=7e66d233"
var script = {}
import style0 from "./NetflixCopyright.vue?vue&type=style&index=0&id=7e66d233&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports